import { Box } from "@mui/material";
import { forwardRef } from "react";
import type { TopItemListProps } from "react-virtuoso";

export const VirtuosoTopItemList = forwardRef<HTMLDivElement, TopItemListProps>(
  ({ children, style, ...props }, ref) => {
    return (
      <Box {...props} style={{ ...style, zIndex: 2 }} ref={ref}>
        {children}
      </Box>
    );
  }
);
